<template>
    <section class="login-outer-container d-flex justify-center align-center">
        <div style="width:500px">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-card class="pt-7 login-vcard" :style="{background: $vuetify.theme.themes['dark'].login_container_bg}">
                            <img style="width:180px;margin-left:auto;margin-right:auto;" class="d-block" :src="$siteLogo">
                            <div class="px-4 pb-4">
                                <v-container fluid>
                                    <v-form @submit.prevent="verifytwofactor()" class="two-factor-form">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <!-- <v-img height="250" src="./images/login-bg.jpg"></v-img> -->
                                                <div class="text-center mt-5" style="border-bottom: none; background-color: transparent; color: white;">
                                                    <h3>Verify it's you</h3>
                                                    <p class="card-text text-center">We sent a verification code to your mobile. <br />Enter the code from your mobile in the field below.</p>
                                                </div>
                                                <!-- <div class="text-center mt-5" style="border-bottom: none;"><h3>Agent portal</h3></div> -->
                                                <hr/>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field autofocus v-model="form.twofactorcode" outlined dense label="6-digit code" :error-messages="formerror.twofactorcode"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn block color="login_button" type="submit">Verify code</v-btn>
                                            </v-col>
                                            <v-col cols="6" class="mt-2 pr-2">
                                                <v-btn block color="error" @click="canceltwofactor">Cancel</v-btn>
                                            </v-col>
                                            <v-col cols="6" class="mt-2 pl-2">
                                                <v-btn block color="info" @click="resendtwofactor">Resend</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </div>
                       </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                formerror: {
                    twofactorcode: [],
                },
                form: new this.$Form({
                    usertoken: this.$store.state.currentUserToken,
                    twofactorcode: '',
                }),
            };
        },
        methods:{
            resendtwofactor(){
                this.form
                .post(this.$_CONFIG.api('API_AUTH_RESEND')).then((data) => {
                    this.$toast.fire({ icon: 'success', title: "Resend verification", text: "Two factor authentication code has been resent to your mobile number." });
                }).catch((err) => { 
                    this.formerror = err.response.data.errors;
                }).finally((res)=>{ 
                    
                });
            },
            canceltwofactor(){
                this.form
                .post(this.$_CONFIG.api('API_AUTH_CANCEL')).then((data) => {
                    this.$store.dispatch("logout");
                    this.$router.push({path: '/login'});
                }).catch((err) => { 
                    this.formerror = err.response.data.errors;
                }).finally((res)=>{ 

                });
            },
            verifytwofactor(){
                this.form
                .post(this.$_CONFIG.api('API_AUTH_VERIFY')).then((data) => {
                    this.$store.commit("twoFactorSuccess");
                    this.$router.push({path: '/'});
                }).catch((err) => { 
                    this.formerror = err.response.data.errors;
                    this.$toast.fire({ icon: 'error', title: "Error", text: "Invalid two factor code." });
                }).finally((res)=>{

                });
            }
        },
        computed: {

        },
        created(){

        },
        mounted() {
            
        }
    }
</script>
